export default __webpack_public_path__ + "locales/hy-AM/VersionHistory.json?hash=a244feeb26dfba987c665963c348534d";